import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "react-chartjs-2";

import { useConfig } from "../../../context/config-context";
import { isLecigimonPatient } from "../../../utils";

const FluxBolus = ({ metrics, patient }) => {
  Chart.register(ChartDataLabels);

  const siteConfig = useConfig();
  const tabConfig = siteConfig.components.patient_tabs.find(
    (t) => t.id === "flux-bolus"
  );

  const isLecigimon = isLecigimonPatient(patient);


  return (
    <div className="flex flex-col justify-center gap-3">
      {!metrics ? (
        <div className="w-full my-5 text-center text-neutral-dark">
          {tabConfig.none}
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
            {tabConfig.graphs.map((graph, index) => (
              <div key={index} className={graph.className}>
                <graph.element
                  data={graph.dataConfig(metrics, isLecigimon)}
                  options={graph.options}
                  plugins={graph.plugins}
                />
              </div>
            ))}
          </div>
          <div className="flex flex-col justify-center gap-3">
            <label className="pb-1 font-semibold border-b border-b-neutral-lighter">
              Bolus
            </label>
            {isLecigimon ? (
              <>
                <div className="flex flex-col justify-center">
                  <label className="font-semibold">Bolus matinal:</label>
                  {metrics["bolusMatin"] != null && (
                    <span>{metrics["bolusMatin"]} ml</span>
                  )}
                </div>
                <div className="flex flex-col justify-center">
                  <label className="font-semibold">Bolus supplémentaire:</label>
                  {metrics["bolusSupp-v5"] != null && metrics["bolusSupp-v7"] != null && (
                    <span>
                      {metrics["bolusSupp-v5"]} ml.max {metrics["bolusSupp-v7"]}/jour
                    </span>
                  )}
                </div>
              </>
            ) : (
              <div className="flex flex-col justify-center">
                <label className="font-semibold">Dosage total sur 24h:</label>
                {metrics["bolus-v5"] && metrics["bolus-v7"] && (
                  <span>
                    {metrics["bolus-v5"]} mg.max {metrics["bolus-v7"]}/jours
                  </span>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default FluxBolus;
